import { render } from "./DialogDemo.vue?vue&type=template&id=6b44883c"
import script from "./DialogDemo.vue?vue&type=script&lang=js"
export * from "./DialogDemo.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/other/drag/components/DialogDemo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b44883c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b44883c', __exports__)) {
    console.log('reload')
    api.reload('6b44883c', __exports__)
  }
  
  module.hot.accept("./DialogDemo.vue?vue&type=template&id=6b44883c", () => {
    console.log('re-render')
    api.rerender('6b44883c', render)
  })

}


export default __exports__